// Use environment variable or fallback to '/backend'
export const API_BASE = 'https://lumieresdejardin.fr/backend';

// Enregistrement d'un nouvel utilisateur
export async function register(email, password) {
  const res = await fetch(`${API_BASE}/user/register.php`, {
    method: 'POST',
    body: new URLSearchParams({ email, password }),
  });
  return res.text();
}

// Connexion d'un utilisateur
export async function login(email, password) {
  const res = await fetch(`${API_BASE}/user/login.php`, {
    method: 'POST',
    credentials: 'include',  // For cookies/session
    body: new URLSearchParams({ email, password }),
  });
  return res.text();
}

// Ajout d'un device avec MAC address et site/location
export async function addDevice(name, ip, mac, locationId) {
  const res = await fetch(`${API_BASE}/devices/add_device.php`, {
    method: 'POST',
    credentials: 'include',
    body: new URLSearchParams({ name, ip, mac, location_id: locationId }),
  });
  return res.text();
}

// Récupère les devices, possibilité de filtrer par site/location
export async function getDevices(locationId = null) {
  let url = `${API_BASE}/devices/get_devices.php`;
  if (locationId !== null && locationId !== undefined) {
    url += `?location_id=${encodeURIComponent(locationId)}`;
  }
  const res = await fetch(url, {
    credentials: 'include',
  });
  return res.json();
}

// Envoie une commande à un device via son IP (proxy PHP)
export async function sendCommand(ip, command) {
  const res = await fetch(
    `${API_BASE}/devices/device_proxy.php?cmd=${encodeURIComponent(command)}&ip=${encodeURIComponent(ip)}`,
    { credentials: 'include' }
  );
  return res.text();
}

// (Optionnel) Récupère la liste des sites/locations de l'utilisateur
export async function getLocations() {
  const res = await fetch(`${API_BASE}/locations/get_locations.php`, {
    credentials: 'include',
  });
  return res.json();
}